import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useIsMobile, useUtility, Stack, Text, shape, Button } from '@hub-la/design-system';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { alpha } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { getAppUrl } from '../utils/routes.js';
import { BackButton } from './back-button.js';
import { Overlay } from './overlay/overlay.js';
import UserNavigation from './user-navigation.js';

const Error = ({
  errorKey
}) => {
  const isMobile = useIsMobile();
  const {
    t
  } = useTranslation();
  const {
    palette
  } = useUtility();
  return jsxs(Stack, Object.assign({
    flex: 1,
    position: "relative",
    minHeight: "100vh"
  }, {
    children: [!isMobile && jsx(Overlay, {}), jsxs(Stack, Object.assign({
      paddingX: [4, 10],
      height: "110px",
      alignItems: "center",
      direction: "row"
    }, {
      children: [jsxs(Stack, Object.assign({
        flex: 1,
        gap: [1, 4],
        direction: "row",
        alignItems: "center"
      }, {
        children: [jsx(BackButton, {}), jsx(Text, Object.assign({
          color: "onBackground",
          variant: "h4",
          style: {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            maxWidth: '55vw'
          }
        }, {
          children: t('postDetail.errorComponent.back')
        }))]
      })), jsx(UserNavigation, {})]
    })), jsx(Stack, Object.assign({
      id: "post-detail",
      direction: "row",
      justifyContent: "center",
      spacing: 4,
      px: [4, 10],
      pb: 30,
      bgcolor: "rgba(22, 31, 0, 0.05)"
    }, {
      children: jsxs(Stack, Object.assign({
        direction: "column",
        spacing: 2,
        position: "relative",
        width: '100%',
        borderRadius: 3,
        border: 1,
        borderColor: alpha(palette('onSurface'), 0.2),
        bgcolor: palette('surface'),
        style: {
          aspectRatio: '16/9',
          overflow: 'hidden'
        },
        alignItems: "center",
        justifyContent: "center",
        maxWidth: 1200
      }, {
        children: [jsx(Stack, Object.assign({
          bgcolor: palette('surfaceVariant'),
          width: 88,
          height: 88,
          justifyContent: "center",
          alignItems: "center",
          borderRadius: shape('full'),
          mb: 4
        }, {
          children: jsx(ErrorOutlineOutlinedIcon, {
            sx: {
              fontSize: 42
            }
          })
        })), jsx(Text, Object.assign({
          color: "onSurfaceVariant",
          textAlign: "center"
        }, {
          children: errorKey ? t(`postDetail.${errorKey}`) : t('postDetail.errors.general')
        })), jsx("a", Object.assign({
          href: getAppUrl('/user_groups')
        }, {
          children: jsx(Button, Object.assign({
            variant: "outlined",
            mt: 2
          }, {
            children: t('postDetail.errorComponent.myPurchases')
          }))
        }))]
      }))
    }))]
  }));
};

export { Error };
